import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { GameCollectStation, NetworkConstants } from 'diwimamodelweb/lib';
import { diffObject, updatesToFirestoreUpdates } from 'diwimamodelweb/lib/utils/obejct-diff';
import { take } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib';
import { Firestore, collection, deleteDoc, doc, setDoc, updateDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class GameCollectStationService {
  private Ifirestore = inject(Firestore);

  constructor(
    private transactionLogService: TransactionLogService,
    private settingsService: SettingsService,
    private userService: UserService,
    private firestore: AngularFirestore
  ) { }

  createGameCollectStation(newCollectStation: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_GAME_COLLECT_STATION))
      // const docRef = this.firestore.collection(NetworkConstants.COLLECTION_GAME_COLLECT_STATION).doc().ref
      const now = new Date()
      newCollectStation['identifier'] = docRef.id
      newCollectStation['creationDate'] = now
      newCollectStation['updateTimestamp'] = now
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No context id")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newCollectStation.identifier, NetworkConstants.COLLECTION_GAME_COLLECT_STATION, newCollectStation)
        newCollectStation['contextId'] = contextId
        await setDoc(docRef,{...newCollectStation} )
       // await this.firestore.collection(NetworkConstants.COLLECTION_GAME_COLLECT_STATION).doc(newCollectStation.identifier).set({...newCollectStation})
        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  updateGameCollectStation(oldCollectStation: GameCollectStation, newCollectStation: GameCollectStation): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldCollectStation, newCollectStation, {})
      const map = updatesToFirestoreUpdates(updates)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService
          .determineDiff(user, updates, newCollectStation.identifier, NetworkConstants.COLLECTION_GAME_COLLECT_STATION)
        map['updateTimestamp'] = new Date()
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_GAME_COLLECT_STATION, newCollectStation.identifier)
        await updateDoc( docRef, map)

        // await this.firestore.collection(NetworkConstants.COLLECTION_GAME_COLLECT_STATION).doc(newCollectStation.identifier).update(map)
        // if successfull save transactionlog..
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  deleteGameCollectStation(gameCollectStation: GameCollectStation): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const personToDelete = deepCopy(gameCollectStation, gameCollectStation.replacerFn)
        const dataToDelete = removeUndefined(personToDelete)
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          gameCollectStation.identifier,
          NetworkConstants.COLLECTION_GAME_COLLECT_STATION,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_GAME_COLLECT_STATION).doc(gameCollectStation.identifier).delete()

        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_GAME_COLLECT_STATION, gameCollectStation.identifier)
        const delOperation = await deleteDoc( docRef)
        promiseArray.push(delOperation)
        resolve()
      } catch (error) {
        reject(error)        
      } 
    })
  }

}
